import React, { useEffect, useState } from "react";
import { withRouter, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import cogoToast from "cogo-toast";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import CipHeader from "../../Components/CipHeader";
import { kaReducer, Table } from "ka-table";
import { loadData, updateData } from "ka-table/actionCreators";
import { SortingMode, PagingPosition } from "ka-table/enums";
import moment from "moment";
import patientService from "../../services/patient-service";
import NumberOfDaysSupplyInput from "./days-supply-input";
import StartDatePickerComponent from "./start-date";
import CourtMedCheckBox from "./court-med-checkbox";

const ReleasePatientMedication = ({ history }) => {

    const location = useLocation();
    const state = location.state;
    const [modifiedData, setModifiedData] = useState([]);

    const tablePropsInit = {
        columns: [
            { key: "pat_name", title: "Patient Name" },
            { key: "drg_name", title: "Drug Name" },
            { key: "rxf_sig", title: "SIG" },
            { key: "courtMed", title: "Court Med" },
            { key: "startDate", title: "Estimated Release Date" },
            { key: "days_supply", title: "No. Of Days Supply" },
        ],
        singleAction: loadData,
        sortingMode: SortingMode.Single,
        rowKeyField: "rxf_id",
        paging: {
            enabled: true,
            pageIndex: 0,
            pageSize: 10,
            position: PagingPosition.Bottom,
        },
    };

    const [tableProps, changeTableProps] = useState(tablePropsInit);
    const [loading, setLoading] = useState(false);
    const dispatch = async (action) => {
        changeTableProps((prevState) => kaReducer(prevState, action));
        if (action.type === 'UpdateCellValue') {
            if (action.cellComponentType === 'DaysSupplyInput') {
                let idx = modifiedData.findIndex((elem) => elem.rxf_id === action.rowKeyValue);
                if (idx > -1) {
                    modifiedData[idx].days_supply = action.value;
                    setModifiedData(modifiedData);
                } else {
                    let idx1 = state.findIndex(
                        (elem) => elem.rxf_id === action.rowKeyValue
                    );
                    state[idx1].days_supply = action.value;
                    setModifiedData([...modifiedData, state[idx1]]);
                }
            } else if (action.cellComponentType === 'StartDatePicker') {
                let idx = modifiedData.findIndex((elem) => elem.rxf_id === action.rowKeyValue);
                if (idx > -1) {
                    modifiedData[idx].startDate = action.value;
                    setModifiedData(modifiedData);
                } else {
                    let idx1 = state.findIndex(
                        (elem) => elem.rxf_id === action.rowKeyValue
                    );
                    state[idx1].startDate = action.value;
                    setModifiedData([...modifiedData, state[idx1]]);
                }
            } else if (action.cellComponentType === 'CourtMed') {
                let idx = modifiedData.findIndex((elem) => elem.rxf_id === action.rowKeyValue);
                if (idx > -1) {
                    modifiedData[idx].courtMed = action.value;
                    setModifiedData(modifiedData);
                } else {
                    let idx1 = state.findIndex(
                        (elem) => elem.rxf_id === action.rowKeyValue
                    );
                    state[idx1].courtMed = action.value;
                    setModifiedData([...modifiedData, state[idx1]]);
                }
            }
            
        }
    };

    useEffect(() => {
        dispatch(updateData(state));
    }, [state])

    const handleSubmitButton = async () => {
        const isSubmitEnabled = modifiedData.length === state.length ? modifiedData.every((item) => {
            const daysSupply = item.days_supply;
            return daysSupply && !isNaN(daysSupply) && daysSupply >= 1 && daysSupply <= 30;
        }) : false;

        if (isSubmitEnabled) {
            let subRec = [];
            setLoading(true);
            modifiedData.map((rec) => {
                subRec.push({
                    rxf_id: rec.rxf_id,
                    org_date: rec.startDate ? rec.startDate : moment().toDate(),
                    days_supply: Number(rec.days_supply),
                    court_med: rec.courtMed ? 'T' : 'F',
                });
                return true;
            });
            const response = await patientService.releasePatientMedication(subRec);
            if (Object.keys(response).length === 0 && response.constructor === Object) {
                const { hide } = cogoToast.success("Medication Release Successfull", {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                });
                setLoading(false);
                await history.push("/patientDetails", { pat_id: state[0].pat_id });
            } else {
                setLoading(false);
                const { hide } = cogoToast.error("Error in submitting Medications", {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                });
                return;
            }
            setLoading(false);
        }
        else {
            setLoading(false);
            const { hide } = cogoToast.error("Please Fill all the Days Supply", {
                hideAfter: 15,
                onClick: () => {
                    hide();
                },
            });
            return;
        }
    }

    return (
        <>
            <CipHeader />
            <div
                className={`inline-block customtop absolute ${loading ? "show" : "hidden"
                    }`}
            >
                <Loader
                    type="Oval"
                    color="#00BFFF"
                    height={50}
                    width={50}
                    timeout={300000}
                />
            </div>
            <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
                <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
                    <div className="w-1/2 text-darkclr font-semibold leading-10 ">
                        <span className="text-xl">RELEASE MEDICATIONS</span>
                    </div>
                </div>
                <div className={`p-2 text-xs patientDetails gridList overflow-x-auto`}
                >
                    <Table
                        className="table-fixed"
                        {...tableProps}
                        childComponents={{
                            cellText: {
                                content: (props) => {
                                    // eslint-disable-next-line default-case
                                    switch (props.column.key) {
                                        case "courtMed":
                                            return <CourtMedCheckBox
                                                {...props}
                                                column={props.column}
                                                dispatch={props.dispatch}
                                                rowData={props.rowData}
                                            />;
                                        case "startDate":
                                            return <StartDatePickerComponent
                                                {...props}
                                                column={props.column}
                                                dispatch={props.dispatch}
                                                value={props.value}
                                                rowData={props.rowData}
                                            />;
                                        case "days_supply":
                                            return <NumberOfDaysSupplyInput
                                                {...props}
                                                column={props.column}
                                                dispatch={props.dispatch}
                                                value={props.value}
                                                rowData={props.rowData}
                                            />
                                    }
                                },
                            },
                        }}
                        dispatch={dispatch}
                    />
                    <div className="w-full mb-2 inline-block">
                        <div className="flex flex-row justify-end">
                            <button
                                type="button"
                                className={
                                    loading
                                      ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-8 px-6 mr-2  bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                                      : "text-white w-full sm:w-auto h-8 px-6 mr-2  bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                                  }
                                onClick={handleSubmitButton}
                            >
                                SUBMIT
                            </button>
                            <button
                                type="button"
                                className={`text-white w-full sm:w-auto h-8 px-6 
              bg-grey rounded text-xs font-medium capitalize 
              focus:outline-none float-right inline-block mr-4
                                    }`}
                                onClick={async () => {
                                    await history.push("/patientDetails", { pat_id: state[0].pat_id });
                                }}
                            >
                                CANCEL
                            </button>
                        </div>

                    </div>
                </div>
            </div>

        </>
    )
}

export default withRouter(
    connect(
        () => ({}),
        (dispatch) => {
            return bindActionCreators({}, dispatch);
        }
    )(ReleasePatientMedication)
);